<template>
<div>
    
    <br/><br/>
    <div style="text-align: left;">
        <a-spin :spinning="spinning">
        <a-form :form="form"  >
            
                
                    <a-form-item label="学校/单位" style="width:50%;font-weight:bold">
                        <a-input
                                @input="handleInput"
                                
                                style="width:167%; margin-left: 5vw;"
                                v-decorator="['organization', { rules: [{ required: true, message: '必填项，不能为空' }] }]"
                        />
                    </a-form-item>
                

                
                    <a-form-item label="第一联系人" style="width:50%;font-weight:bold">
                        <a-input
                                @input="handleInput"
                                
                                style="width:167%;margin-left: 5vw;"
                                v-decorator="['teamLeader', { rules: [{ required: true, message: '必填项，不能为空' }] }]"
                        />
                    </a-form-item>
                

                
                    <a-form-item label="联系方式" style="width:50%;font-weight:bold">
                        <a-input
                                @input="handleInput"
                                
                                style="width:167%;margin-left: 5vw;"
                                v-decorator="['phone', { rules: [{ required: true, message: '必填项，不能为空' }] }]"
                        />
                    </a-form-item>
                

                
                    <a-form-item label="团队成员" style="width:50%;font-weight:bold">
                        <a-input
                                @input="handleInput"
                                
                                style="width:167%;margin-left: 5vw;"
                                v-decorator="['teamMembers', { rules: [{ required: true, message: '必填项，不能为空' }] }]"
                        />
                    </a-form-item>
                

                
                    <a-form-item label="作品名称" style="width:50%;font-weight:bold">
                        <a-input
                                @input="handleInput"
                                
                                style="width:167%;margin-left: 5vw;"
                                v-decorator="['name', { rules: [{ required: true, message: '必填项，不能为空' }] }]"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-upload
                                name="attachFile"
                                :multiple="false"
                                :headers="headers"
                                :before-upload="beforeUpload"
                                style="margin-left: 5vw"
                                
                                v-decorator="['attachFile', { rules: [{  required: true, message: '请添加文件' }] }]"
                        >
                                <a-button> <a-icon type="upload" /> 添加附件 </a-button>
                        </a-upload>
                    </a-form-item>
            
               
            
            
        </a-form>
        </a-spin>
    </div>
    
    <div>
        <a-row>
            <a-col a-col span="6"  align="middle">
            </a-col>
            <a-col a-col span="6"  align="middle">
                <a-button  @click="handleUrl()" style="margin-bottom: 5vw">返回</a-button>
            </a-col>
            <a-col a-col span="6"  align="middle">
                <a-button type="primary" @click="addDrEvent()" style="margin-bottom: 5vw">提交</a-button>
            </a-col>
            <a-col a-col span="6"  align="middle">
            </a-col>
        </a-row>
    </div>
</div>
   
</template>

<style scoped>
.ant-input {
    width: 100%;
   
}
.ant-form-item-label label{
    margin-left: 5vw;
}
.ant-form-explain, .ant-form-extra {
    margin-left: 5vw;
}
</style>


<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

 const columns = [
        {
            title:'序号',
            customRender:(text,record,index)=>`${index+1}`,
            width:60
        },
        {
            title: '设备名称',
            dataIndex: 'name',
            key: 'name',
            width: 120,
        },
        {
            title: '设备sn',
            key: 'sn',
            dataIndex: 'sn',
            width: 100,
            scopedSlots: { customRender: 'sn' },
            className: 'col-package'
        },
         {
            title: '用户邮箱',
            dataIndex: 'email',
            width:100,
            key: 'email',
        },
        
 ];
 

export default {
    data(){
        return{
            locale: zhCN,
            beginDate:"",
            beginDateTime:"",
            endDate:"",
            endDateTime:"",
            deviceName:"",
            result:[],
            spinning: false,
            columns,
            selectList:"",
            form: this.$form.createForm(this),
            headers: {
                    authorization: 'authorization-text',
            },
            pagination: {
                // 默认当前页，每页显示数量，总数
                current: 1, 
                pageSize: 20,
                total: 0,
                showSizeChanger: true, //可改变每页数量
                pageSizeOptions: ['20', '50', '100'],
                showTotal: total => `共 ${total} 条`,
                onChange: (current, pageSize) => this.pageChange(current, pageSize),
                onShowSizeChange: (current, pageSize) => this.pageSizeChange(current, pageSize)
                },
            rowSelection: {
                onChange: (selectedRowKeys, selectedRows) => this.onSelectChange(selectedRowKeys, selectedRows),
                onSelect: (record, selected, selectedRows) => {
                console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                console.log(selected, selectedRows, changeRows);
            },
  }
        }
    },
    
    created: function(){
            this.getDeviceList()
        },
    
    methods:{
        onChange(date, dateString) {
        this.beginDate = dateString;
        console.log(date, dateString);
        console.log(this.beginDate)
        },
        onChangeTime(time, timeString){
        this.beginDateTime = timeString;
        console.log(time, timeString);
        },
        onEndChange(date, dateString) {
        this.endDate = dateString;
        console.log(date, dateString);
        console.log(this.beginDate)
        },
        onEndChangeTime(time, timeString){
        this.endDateTime = timeString;
        console.log(time, timeString);
        },
        handleInput(e){
            this.deviceName = e.target.values
            console.log(this.deviceName)
        },
        beforeUpload() {
                return false;
            },
        getDeviceList(){
                this.pagination.current = this.pagination.current?this.pagination.current:1;
                //let url =  "http://120.26.227.25:8809/ac-energy/DR/getApplianceStatus?page="+ this.pagination.current + '&size=' + this.pagination.pageSize;
                let url =  "/ac-energy/DR/getApplianceStatus?page="+ this.pagination.current + '&size=' + this.pagination.pageSize;
                let vm = this;
                this.axios.get(url).then(response => {
                    vm.result = response.data.result.list
                    vm.pagination = response.data.result
                    vm.pagination.current = response.data.result.page
                
                })
        },
        addDrEvent(){
            
            var vm = this;
            this.form.validateFields((err, values) => {
                    if (!err) {
                        let tempUrl = window.location.href;
                        let arr = tempUrl.split('#');
                        let formData = new FormData();
                        formData.append("name",values.name);
                        formData.append("openId",arr[1]);
                        formData.append("organization",values.organization);
                        formData.append("teamLeader",values.teamLeader);
                        formData.append("phone",values.phone);
                        formData.append("teamMembers",values.teamMembers);
                        formData.append("attach",values.attachFile.file);
                        this.spinning = true;
                        this.axios.post("/ac-manage/creation/add", formData,{'Content-Type':'multiple/form-data'}).then(response => {
                        console.log(response.data);
                        vm.spinning = false;
                        if (response.data.errCode == "0") {
                            vm.$message.success('上传成功');
                            vm.modal1visible = false;
                            vm.form.resetFields();
                            vm.handleUrl();
                            //vm.$router.push('/dr-event')
                        } else {
                            vm.$message.error(response.data.errMsg);
                        }
                        });
                    }
            });
                 
        },
        pageChange (current, pageSize) {
                this.pagination.current = current
                //下面再请求分页接口，重新渲染数据
            },
        pageSizeChange (current, pageSize) {
            this.pagination.pageSize = pageSize
            this.getDeviceList();
            // 请求分页接口，重新渲染数据
        },
        onSelectChange(selectedRowKeys, selectedRows){
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            if(selectedRows.length == 1){
                this.selectList = selectedRows[0].sn
            }
            else{
                for(let i = 0, k= selectedRows.length;i < selectedRows.length -1 ; i++){
                        this.selectList = this.selectList + selectedRows[i].sn + ',';
                }
                this.selectList = this.selectList + selectedRows[selectedRows.length -1].sn   
            }
        },
        handleUrl(){
            let tempUrl = window.location.href;
            let arr = tempUrl.split('#');
            let url =  "creationlist.html#" + arr[1];
            location.href= url
        },
        uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                console.log(s.join(""), 's.join("")');
                return uuid;
            },
        
    }
}
</script>